import { render, staticRenderFns } from "./VeeSelect.vue?vue&type=template&id=44355155&"
import script from "./VeeSelect.vue?vue&type=script&lang=js&"
export * from "./VeeSelect.vue?vue&type=script&lang=js&"
import style0 from "./VeeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports